import React from "react";

const Subtitle3 = ({ content }) => {
  return (
    <div className="articleRender-container subtitle3Block">{content.text}</div>
  );
};

export default Subtitle3;
